import { api } from '../../../lib/api'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED'

export const resetPassword = function (data, onComplete) {
  return function (dispatch) {
    dispatch({
      type: RESET_PASSWORD_REQUEST
    })
    api.resetPassword(data).then(resetPasswordResponse => {
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
        payload: resetPasswordResponse
      })
      if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: RESET_PASSWORD_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile/reset-password.js